import { Clock } from "lucide-react";
import type { ReactNode } from "react";

import type { StalenessBreakdown } from "@busright/data-contract";

import { formatPct, relativeFromNow } from "@/lib/format";

// =================================================================================================
// TelFreshnessMonitor — freshness DEMOTED to a small monitor chip (+ subnote), no longer the
// headline of the surface. The full StalenessBadge banner treatment moved out of the top of the
// page; this is a compact, always-visible strip so the honesty caveat is still present without
// dominating the story.
// =================================================================================================

export interface TelFreshnessMonitorProps {
  readonly staleness: StalenessBreakdown;
}

export const TelFreshnessMonitor = ({ staleness }: TelFreshnessMonitorProps): ReactNode => (
  <div className="tel-freshness-monitor">
    <Clock size={13} aria-hidden />
    <span className="br-tabular-nums">{formatPct(staleness.stalePct)}</span> of readings &gt;2 days
    old
    <span className="tel-freshness-monitor-sub">
      latest reading {relativeFromNow(staleness.latestReadingAt)}
    </span>
  </div>
);
